module.exports = __webpack_public_path__ + "static/media/20.94e32483.jpg";